import { formatWholeMoney } from '../../lib/currency';

/** Cents to the house whole-dollar format. */
export const dollars = (cents: number): string => formatWholeMoney(cents / 100);

/** Inflows, Outflows and Net cash flow (docs/39 decision 1). */
export function Figures({ inflowCents, outflowCents }: { inflowCents: number; outflowCents: number }) {
  const items: [string, number][] = [
    ['Inflows', inflowCents],
    ['Outflows', outflowCents],
    ['Net cash flow', inflowCents - outflowCents],
  ];
  return (
    <dl className="grid grid-cols-3 max-sm:grid-cols-1 gap-4 m-0 mb-6">
      {items.map(([label, cents]) => (
        <div key={label} className="bg-card border border-line rounded-token p-4">
          <dt className="text-[11px] uppercase tracking-[0.1em] text-slate font-sans">{label}</dt>
          <dd className="m-0 mt-1 font-serif text-[24px] text-navy">{dollars(cents)}</dd>
        </div>
      ))}
    </dl>
  );
}

export const UNPREPARED_MESSAGE = 'Steward is still preparing this month. Please check back soon.';
export const NO_TRANSACTIONS_MESSAGE = 'Steward found no transactions for this month.';
/** A computed month that holds no transaction at all. A legacy row without a count is not assumed empty. */
export const isEmptyMonth = (m: { empty?: boolean | null }): boolean => m.empty === true;
